import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-20 min-h-screen flex items-center justify-center">
        <div className="text-center px-4">
          <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100">
            <i className="ri-emotion-sad-line text-4xl text-foreground-400"></i>
          </div>
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            404
          </h1>
          <p className="text-sm text-foreground-600 mb-8">
            抱歉，您要查看的页面不存在或已被移除
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-line"></i> 返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}